import { Component, inject, OnInit, signal } from '@angular/core';
import {
	ActivatedRoute,
	NavigationEnd,
	Router,
	RouterOutlet,
} from '@angular/router';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { AuthService } from './services/auth.service';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { UserService } from './services/user.service';
import { filter, take } from 'rxjs';
import { LocalStorageService } from './services/localstorageService.service';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, NavbarComponent, FooterComponent, SpinnerComponent],
	templateUrl: './app.component.html',
	styleUrl: './app.component.css',
	standalone: true,
})
export class AppComponent implements OnInit {
	title = 'homeAi';
	readonly userService = inject(UserService);
	private authService = inject(AuthService);
	private localStorage = inject(LocalStorageService);
	private router = inject(Router);
	registerCompleted = signal(false);
	registerTokenNotFound = signal(false);

    navigationType = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
	reload = signal(false);

	ngOnInit() {
		this.localStorage.registerCompleted.subscribe(res => console.log(res))
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => {
				const isReject = this.router.url.startsWith('/reject');

				if (isReject) {
					this.authService.autoLogin(true).subscribe();
					this.router.navigate(['/home']);
				} else {
					this.authService.autoLogin(false).subscribe();
				}
			});

			if (this.navigationType?.type === 'reload') {
				this.reload.set(true);
				this.authService.autoLogin(true).subscribe(
					res => {
						this.reload.set(false);
					}
				);
			}
			
		this.localStorage.registerCompleted.subscribe((value: boolean) => {
			if (value == true) {
				this.authService.confirmRegister().subscribe({
					next: (response) => {
						this.registerCompleted.set(true);
						setTimeout(() => {
							this.registerCompleted.set(false);
							this.localStorage.registerCompleted.next(false);
						}, 13000);
					},
					error: (err) => {
						this.registerTokenNotFound.set(true);
						setTimeout(() => {
							this.registerTokenNotFound.set(false);
							this.localStorage.registerCompleted.next(false);
							this.localStorage.logout();
						}, 13000);
					},
				});
			}
		});
	}
}
